/**
 * @file Created on Fri Feb 01 2019
 * @author SKu
 */
import IndexRenderer from './IndexRenderer';
export default IndexRenderer;